<script setup>
import { ref, onMounted, defineEmits, defineProps } from "vue";
import { editUser } from "@/services/users";
import { getClients } from "@/services/clients";

const props = defineProps(["newKeyData"]);
const emit = defineEmits(["keySaved", "cancelEdit"]);

const isDropdownOpen = ref(false);
const clients = ref([]);
const userData = ref({
  id: "",
  name: "",
  email: "",
  clients_id: "",
  role: 0,
});

onMounted(async () => {
  const response = await getClients();
  console.log("Fetched Projects:", response.data);
  if (response.data.length) {
    clients.value = response.data;
  }
  console.log("CLIENTS:", clients.value);
  if (props.newKeyData) {
    userData.value = {
      id: props.newKeyData.id || "",
      name: props.newKeyData.name || "",
      email: props.newKeyData.email || "",
      clients_id: props.newKeyData.client || "",
      role: props.newKeyData.role || 0,
      password: "password",
    };
  }
});

const roles = ref([
  {
    id: 1,
    title: "Administrador",
  },
  {
    id: 2,
    title: "Editor",
  },
]);

function saveUserAndEmit() {
  if (!userData.value.id) {
    console.error("El ID del usuario es obligatorio y no está definido.");
    return;
  }
  const updatedUserData = {
    id: userData.value.id,
    name: userData.value.name,
    email: userData.value.email,
    roleId: userData.value.role,
    password: userData.value.password,
  };
  console.log("Datos a enviar al servidor:", updatedUserData);
  editUser(updatedUserData)
    .then((response) => {
      const result =
        typeof response.data === "object"
          ? response.data
          : { message: response.data };
      emit("keySaved", result);
      isDropdownOpen.value = false;
    })
    .catch((error) => {
      console.error("Error al actualizar usuario:", error);
    });
}

/* Click fuera del dropdown */
onMounted(() => {
  document.addEventListener("click", (event) => {
    if (!event.target.closest(".dropdown")) {
      isDropdownOpen.value = false;
    }
  });
});

const cancelEdit = () => {
  emit("cancelEdit");
};
</script>
<template>
  <div>
    <article>
      <h5 class="create-title my-4">Editar Usuario</h5>
      <form>
        <div class="mb-3">
          <label
            for="exampleInputEmail1"
            class="form-label globals-label"
            style="font-size: 16px"
            >Nombre (s)</label
          >
          <input
            type="text"
            class="form-control globals-input"
            id="name"
            placeholder="Nombre (s)"
            v-model="userData.name"
          />
        </div>

        <div class="mb-3">
          <label
            for="exampleInputEmail3"
            class="form-label globals-label"
            style="font-size: 16px"
            >Email</label
          >
          <input
            type="email"
            class="form-control globals-input"
            id="email"
            placeholder="Email"
            v-model="userData.email"
          />
        </div>
        <div class="mb-3">
          <label for="exampleInputEmail3" class="form-label globals-label"
            >Cliente</label
          >
          <select
            id="client"
            class="form-select form-select-details"
            v-model="userData.clients_id"
            disabled
          >
            <option
              v-for="client in clients"
              :key="client.clientsId"
              :value="client.clientsId"
            >
              {{ client.companyName }}
            </option>
          </select>
        </div>
        <div class="mb-3">
          <label for="exampleInputEmail3" class="form-label globals-label"
            >Tipo de Usuario</label
          >
          <select
            id="client"
            class="form-select form-select-details"
            v-model="userData.role"
          >
            <optgroup label="Selecciona el tipo de usuario">
              <option v-for="role in roles" :key="role.id" :value="role.id">
                {{ role.title }}
              </option>
            </optgroup>
          </select>
        </div>
      </form>
      <div class="d-flex justify-content-around my-5">
        <button
          class="globals-border-button"
          @click="cancelEdit"
          data-bs-dismiss="offcanvas"
        >
          Cancelar
        </button>
        <button class="globals-button" @click.prevent="saveUserAndEmit">
          Guardar Cambios
        </button>
      </div>
    </article>
  </div>
</template>
